import React, { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

const PDF_URL = 'https://utrvslwjxcvnctjfomit.supabase.co/storage/v1/object/public/resources/LCA_Rescission_Calendar_2026.pdf'

const US_STATES = [
  '', 'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA','HI','ID','IL','IN','IA','KS','KY',
  'LA','ME','MD','MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ','NM','NY','NC','ND','OH',
  'OK','OR','PA','RI','SC','SD','TN','TX','UT','VT','VA','WA','WV','WI','WY','DC'
]

const STYLES = `
  * { box-sizing: border-box; }
  body { margin: 0; }
  .lp-wrap { min-height:100vh; background:linear-gradient(135deg,#F7F8F9 0%,#F5F6F7 100%); font-family:Georgia,serif; color:#1A1A1A; padding:20px 16px; }
  .lp-container { max-width:920px; margin:0 auto; }

  /* HEADER BAR - stacked layout */
  .lp-header { display:flex; flex-direction:column; align-items:center; padding:18px 0; margin-bottom:20px; gap:14px; }
  .lp-header-brand { font-size:14px; letter-spacing:0.16em; color:#41427a; text-transform:uppercase; font-weight:700; text-align:center; }
  .lp-header-brand strong { color:#151715; font-weight:800; }
  .lp-login-btn-wrap { width:100%; display:flex; justify-content:flex-end; }
  .lp-login-btn { padding:10px 22px; border:none; border-radius:8px; background:linear-gradient(135deg,#4D4E8D,#41427a); color:#fff; text-decoration:none; font-size:13px; font-weight:700; letter-spacing:0.04em; transition:all 0.2s; box-shadow:0 3px 12px rgba(77,78,141,0.3); }
  .lp-login-btn:hover { transform:translateY(-1px); box-shadow:0 5px 18px rgba(77,78,141,0.45); background:linear-gradient(135deg,#6E70AE,#4D4E8D); }
  @media (max-width: 600px) {
    .lp-header-brand { font-size:11px; letter-spacing:0.1em; }
    .lp-login-btn-wrap { justify-content:center; }
  }

  /* HERO - cozier!! */
  .lp-hero { background:#fff; border-radius:20px; padding:32px 28px; margin-bottom:24px; box-shadow:0 8px 40px rgba(21,23,21,0.08); text-align:center; position:relative; overflow:hidden; max-width:620px; margin-left:auto; margin-right:auto; }
  .lp-hero::before { content:''; position:absolute; top:-80px; right:-80px; width:220px; height:220px; background:radial-gradient(circle,rgba(77,78,141,0.12),transparent 70%); pointer-events:none; }
  .lp-seal { width:90px; height:90px; margin:0 auto 12px; display:block; object-fit:contain; }
  .lp-title { font-size:32px; font-weight:700; color:#151715; margin:0 0 8px; line-height:1.2; letter-spacing:-0.01em; }
  .lp-subtitle { font-size:16px; color:#5C6065; max-width:520px; margin:0 auto 6px; line-height:1.5; font-weight:400; }
  .lp-from-tribe { font-size:13px; color:#41427a; font-style:italic; margin-bottom:0; }
  @media (max-width: 600px) {
    .lp-title { font-size:26px; }
    .lp-subtitle { font-size:14px; }
    .lp-hero { padding:26px 20px; border-radius:18px; }
    .lp-seal { width:75px; height:75px; }
  }

  /* TWO COL LAYOUT */
  .lp-grid { display:grid; grid-template-columns:1fr 1fr; gap:24px; margin-bottom:24px; }
  @media (max-width: 760px) { .lp-grid { grid-template-columns:1fr; } }

  /* PREVIEW CARD */
  .lp-preview { background:#fff; border-radius:20px; padding:32px 28px; box-shadow:0 4px 24px rgba(21,23,21,0.06); }
  .lp-preview-img-wrap { background:linear-gradient(135deg,#4D4E8D,#41427a); border-radius:14px; padding:24px; margin-bottom:20px; text-align:center; box-shadow:0 6px 20px rgba(21,23,21,0.2); position:relative; }
  .lp-preview-pages { font-size:11px; color:#fff; letter-spacing:0.14em; margin-bottom:8px; font-weight:600; }
  .lp-preview-pdf-name { font-family:Georgia,serif; font-size:24px; color:#fff; font-weight:600; line-height:1.3; }
  .lp-preview-pdf-year { color:#fff; font-size:18px; margin-top:4px; }
  .lp-preview-title { font-size:18px; font-weight:700; color:#151715; margin-bottom:14px; }
  .lp-feature-list { list-style:none; padding:0; margin:0; }
  .lp-feature-item { display:flex; gap:10px; padding:8px 0; font-size:13px; color:#3A3D40; line-height:1.6; }
  .lp-feature-icon { color:#5E8A72; font-weight:bold; flex-shrink:0; }

  /* FORM CARD */
  .lp-form-card { background:linear-gradient(135deg,#fff,#FFFDF5); border:2px solid #4D4E8D; border-radius:20px; padding:32px 28px; box-shadow:0 8px 32px rgba(77,78,141,0.15); }
  .lp-form-title { font-size:22px; font-weight:700; color:#151715; margin:0 0 6px; text-align:center; }
  .lp-form-sub { font-size:13px; color:#5C6065; margin-bottom:22px; text-align:center; }
  .lp-row { display:grid; grid-template-columns:1fr 1fr; gap:10px; margin-bottom:12px; }
  @media (max-width: 480px) { .lp-row { grid-template-columns:1fr; } }
  .lp-field { margin-bottom:12px; }
  .lp-label { display:block; font-size:11px; font-weight:600; color:#5C6065; letter-spacing:0.05em; margin-bottom:5px; }
  .lp-input, .lp-select { width:100%; padding:12px 14px; border:1.5px solid #D7DADE; border-radius:10px; font-size:14px; font-family:inherit; box-sizing:border-box; background:#fff; transition:border-color 0.15s; }
  .lp-input:focus, .lp-select:focus { outline:none; border-color:#4D4E8D; box-shadow:0 0 0 3px rgba(77,78,141,0.15); }
  .lp-btn { width:100%; padding:16px 24px; border:none; border-radius:12px; background:linear-gradient(135deg,#4D4E8D,#41427a); color:#fff; font-size:15px; font-weight:700; letter-spacing:0.04em; cursor:pointer; transition:all 0.2s; box-shadow:0 4px 18px rgba(77,78,141,0.3); margin-top:8px; font-family:inherit; }
  .lp-btn:hover:not(:disabled) { transform:translateY(-2px); box-shadow:0 6px 24px rgba(77,78,141,0.45); background:linear-gradient(135deg,#6E70AE,#4D4E8D); }
  .lp-btn:disabled { opacity:0.6; cursor:not-allowed; transform:none; }
  .lp-privacy { font-size:11px; color:#A2A6AA; text-align:center; margin-top:14px; line-height:1.5; }

  /* SUCCESS STATE */
  .lp-success { background:linear-gradient(135deg,#EAF2EE,#F0FAF4); border:2px solid #5E8A72; border-radius:20px; padding:40px 32px; text-align:center; }
  .lp-success-icon { font-size:64px; margin-bottom:14px; }
  .lp-success-title { font-size:28px; font-weight:700; color:#1A4A2E; margin-bottom:10px; }
  .lp-success-text { font-size:15px; color:#4A6850; line-height:1.7; margin-bottom:24px; }
  .lp-download-btn { display:inline-block; padding:18px 36px; background:linear-gradient(135deg,#4D4E8D,#41427a); color:#fff; text-decoration:none; border-radius:12px; font-size:16px; font-weight:700; letter-spacing:0.04em; box-shadow:0 6px 20px rgba(21,23,21,0.3); transition:all 0.2s; }
  .lp-download-btn:hover { transform:translateY(-2px); box-shadow:0 8px 28px rgba(21,23,21,0.4); }
  .lp-email-note { font-size:12px; color:#5C6065; margin-top:18px; font-style:italic; }
  .lp-tribe-invite { background:linear-gradient(135deg,#EEF0F8,#FAFAFF); border:2px solid #6E70AE; border-radius:14px; padding:24px; margin-top:24px; }
  .lp-tribe-title { font-size:18px; font-weight:700; color:#4D4E8D; margin-bottom:8px; }
  .lp-tribe-text { font-size:13px; color:#3A3D40; line-height:1.6; margin-bottom:14px; }
  .lp-tribe-btn { display:inline-block; padding:10px 22px; background:linear-gradient(135deg,#6E70AE,#4D4E8D); color:#fff; text-decoration:none; border-radius:8px; font-size:13px; font-weight:600; }
  .lp-tribe-btn:hover { background:linear-gradient(135deg,#4D4E8D,#41427a); }

  /* CEO QUOTE - SIMPLIFIED, CENTERED, NO AVATAR */
  .lp-ceo-card { background:#fff; border-radius:18px; padding:32px 28px; margin-bottom:24px; box-shadow:0 4px 20px rgba(21,23,21,0.06); text-align:center; }
  .lp-ceo-name { font-size:22px; font-weight:700; color:#151715; margin-bottom:4px; }
  .lp-ceo-title { font-size:12px; color:#41427a; font-weight:600; letter-spacing:0.06em; margin-bottom:14px; text-transform:uppercase; }
  .lp-ceo-quote { font-size:15px; color:#3A3D40; line-height:1.7; font-style:italic; max-width:520px; margin:0 auto; }

  /* FOOTER - CENTERED */
  .lp-footer { text-align:center; padding:30px 20px; color:#5C6065; font-size:12px; line-height:1.8; }
  .lp-footer strong { color:#151715; }
  .lp-footer a { color:#41427a; text-decoration:none; }

  .lp-error { background:#FDF2F2; border:1px solid #E24B4A; color:#A32D2D; padding:10px 14px; border-radius:8px; font-size:13px; margin-bottom:14px; }
`

export default function RescissionCalendarLanding() {
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    notary_state: '',
  })
  const [submitting, setSubmitting] = useState(false)
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState('')

  // Capture UTM parameters from URL
  const [utmParams, setUtmParams] = useState({})
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    setUtmParams({
      utm_source: params.get('utm_source'),
      utm_campaign: params.get('utm_campaign'),
    })
  }, [])

  async function submit(e) {
    if (e) e.preventDefault()
    setError('')

    if (!form.first_name.trim() || !form.last_name.trim() || !form.email.trim()) {
      setError('Please fill in all required fields!!')
      return
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      setError('Please enter a valid email address!!')
      return
    }

    setSubmitting(true)
    try {
      const { error: dbErr } = await supabase.from('marketing_leads').insert({
        first_name: form.first_name.trim(),
        last_name: form.last_name.trim(),
        email: form.email.trim().toLowerCase(),
        notary_state: form.notary_state || null,
        lead_source: 'rescission_calendar_2026',
        utm_source: utmParams.utm_source,
        utm_campaign: utmParams.utm_campaign,
        user_agent: navigator.userAgent.slice(0, 200),
      })
      if (dbErr) throw dbErr

      try {
        await fetch('/.netlify/functions/send-lead-magnet', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            first_name: form.first_name.trim(),
            last_name: form.last_name.trim(),
            email: form.email.trim().toLowerCase(),
            notary_state: form.notary_state || null,
            pdf_url: PDF_URL,
            lead_source: 'rescission_calendar_2026',
          }),
        })
      } catch (emailErr) {
        console.warn('Email send failed (lead is saved):', emailErr)
      }

      setSubmitted(true)
    } catch (err) {
      console.error('Lead submit error:', err)
      setError(`Submission failed: ${err.message}. Please try again or email nancy@notarysigningvault.com directly!!`)
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <>
      <style>{STYLES}</style>
      <div className="lp-wrap">
        <div className="lp-container">

          {/* HEADER BAR - stacked */}
          <div className="lp-header">
            <div className="lp-header-brand">
              <strong>Notary Signing Vault, LLC.</strong> DBA Nationwide Notary Professionals Network
            </div>
            <div className="lp-login-btn-wrap">
              <a href="/login" className="lp-login-btn">Notary Login →</a>
            </div>
          </div>

          {/* HERO */}
          <div className="lp-hero">
            <img src="/nsv_emblem.png?v=2" alt="NSV Logo" className="lp-seal" />
            <h1 className="lp-title">Get Your FREE 2026 Rescission Calendar</h1>
            <div className="lp-subtitle">From the NSV to YOU!!</div>
            <div className="lp-from-tribe">Built by a Notary, for Notaries!! 💜</div>
          </div>

          {submitted ? (
            // ─── SUCCESS STATE ───
            <div className="lp-success">
              <div className="lp-success-icon">🎉</div>
              <div className="lp-success-title">You're All Set, {form.first_name}!!</div>
              <div className="lp-success-text">
                Your 2026 Rescission Calendar is ready to download right now — and a backup copy is on its way to your inbox!! 💜
              </div>

              <a href={PDF_URL} target="_blank" rel="noreferrer" className="lp-download-btn">
                📥 Download Your Calendar
              </a>

              <div className="lp-email-note">
                📧 Check your email at <strong>{form.email}</strong> for a backup copy<br />
                <span style={{ fontSize:11 }}>(Don't see it? Check your spam folder!!)</span>
              </div>

              <div className="lp-tribe-invite">
                <div className="lp-tribe-title">💜 Want MORE Notary Magic??</div>
                <div className="lp-tribe-text">
                  This calendar is just a TASTE of what we build for our notary tribe every day!! Join the NSV Tribe — our private community where notaries grow together, share wins, and shape the future of our industry!!
                </div>
                <a href="/signup" className="lp-tribe-btn">🤝 Apply to Join the NSV Tribe</a>
              </div>
            </div>
          ) : (
            // ─── FORM STATE ───
            <>
              {/* TWO COLUMN: Preview + Form */}
              <div className="lp-grid">

                {/* LEFT: What's Inside */}
                <div className="lp-preview">
                  <div className="lp-preview-img-wrap">
                    <div className="lp-preview-pages">📅 13 PAGES · LANDSCAPE</div>
                    <div className="lp-preview-pdf-name">Rescission Calendar</div>
                    <div className="lp-preview-pdf-year">2026</div>
                  </div>

                  <div className="lp-preview-title">📋 What's Inside:</div>
                  <ul className="lp-feature-list">
                    <li className="lp-feature-item"><span className="lp-feature-icon">✓</span><span>Information page with TILA rescission rules & all 11 federal holidays</span></li>
                    <li className="lp-feature-item"><span className="lp-feature-icon">✓</span><span>12 monthly calendars for all of 2026</span></li>
                    <li className="lp-feature-item"><span className="lp-feature-icon">✓</span><span>"Ends MM/DD" date shown on every business day</span></li>
                    <li className="lp-feature-item"><span className="lp-feature-icon">✓</span><span>Federal holidays marked & excluded automatically</span></li>
                    <li className="lp-feature-item"><span className="lp-feature-icon">✓</span><span>Print-friendly format for your notary bag</span></li>
                    <li className="lp-feature-item"><span className="lp-feature-icon">✓</span><span>100% FREE — no strings attached</span></li>
                  </ul>
                </div>

                {/* RIGHT: Form */}
                <div className="lp-form-card">
                  <div className="lp-form-title">Get Your FREE Copy</div>
                  <div className="lp-form-sub">Tell us where to send it!!</div>

                  {error && <div className="lp-error">⚠️ {error}</div>}

                  <form onSubmit={submit}>
                    <div className="lp-row">
                      <div className="lp-field">
                        <label className="lp-label">FIRST NAME *</label>
                        <input className="lp-input" type="text" required value={form.first_name} onChange={e => setForm(f => ({ ...f, first_name: e.target.value }))} placeholder="Jane" />
                      </div>
                      <div className="lp-field">
                        <label className="lp-label">LAST NAME *</label>
                        <input className="lp-input" type="text" required value={form.last_name} onChange={e => setForm(f => ({ ...f, last_name: e.target.value }))} placeholder="Doe" />
                      </div>
                    </div>

                    <div className="lp-field">
                      <label className="lp-label">EMAIL ADDRESS *</label>
                      <input className="lp-input" type="email" required value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} placeholder="janedoe@notarymail.com" />
                    </div>

                    <div className="lp-field">
                      <label className="lp-label">YOUR COMMISSION STATE (Optional)</label>
                      <select className="lp-select" value={form.notary_state} onChange={e => setForm(f => ({ ...f, notary_state: e.target.value }))}>
                        <option value="">Select your state...</option>
                        {US_STATES.filter(s => s).map(s => <option key={s} value={s}>{s}</option>)}
                      </select>
                    </div>

                    <button type="submit" className="lp-btn" disabled={submitting}>
                      {submitting ? '⏳ Sending...' : '📥 Get My FREE Calendar Now!!'}
                    </button>

                    <div className="lp-privacy">
                      Your info is safe with us. Unsubscribe anytime. 💜
                    </div>
                  </form>
                </div>
              </div>

              {/* CEO QUOTE - simplified, centered, no avatar */}
              <div className="lp-ceo-card">
                <div className="lp-ceo-name">Nancy Phillips</div>
                <div className="lp-ceo-title">Your Friendly CEO & Founder · Notary Signing Vault, LLC.</div>
                <div className="lp-ceo-quote">
                  "From one notary to another — this calendar is my gift to you!! 💜"
                </div>
              </div>
            </>
          )}

          {/* FOOTER */}
          <div className="lp-footer">
            <strong>Notary Signing Vault, LLC.</strong> · DBA Nationwide Notary Professionals Network<br />
            <a href="https://notarysigningvault.com">notarysigningvault.com</a> &nbsp; | &nbsp; (904) 865-0133<br />
            <span style={{ fontSize:10, opacity:0.7 }}>Veteran & Hispanic Family Owned Small Business </span>
          </div>

        </div>
      </div>
    </>
  )
}
